<script setup lang="ts">
import SvgIcon from '@/shared/components/icon/SvgIcon.vue'

interface Props {
  label?: string
  icon: string
  loading?: boolean
}

defineProps<Props>()
</script>

<template>
  <li class="flex items-center justify-start relative">
    <span class="top-0 left-3 absolute w-px h-full bg-gray-300"></span>
    <div class="relative bg-white">
      <SvgIcon :path="icon" class="fill-success w-6 h-6" />
    </div>
    <div class="ml-1 justify-content items-center p-2">
      <div class="flex-auto text-xs">
        <div class="font-bold">{{ label }}</div>
        <div>
          <slot></slot>
        </div>
      </div>
    </div>
  </li>
</template>
